import React from 'react';
import {Route, Switch} from "react-router";
import {LoginContainer} from "./containers/login";
import {Base} from "./components/base";
import {DashBoardContainer} from "./containers/dashboard";
import {RegulationComponent} from "./containers/regulation";
import {TaskComponent} from "./containers/task";
import {ReportComponent} from "./containers/report";
import {CompanyComponent} from "./containers/company";
import {TaskDetailContainer} from "./containers/task/detail";
import {Authenticate} from "./components/authenticate";
import {ClientComponent} from "./containers/client";
import {UserComponent} from "./containers/user";
import {Message} from "./components/message";

export const router = (

    <Base>
        <Switch>
            <Route exact path="/" component={LoginContainer}/>
            <Authenticate>
                <Switch>
                    <Route path="/dashboard" component={DashBoardContainer}/>
                    <Route path="/regulation" component={RegulationComponent}/>
                    <Route path="/task/:id" component={TaskDetailContainer}/>
                    <Route path="/task" component={TaskComponent}/>
                    <Route path="/company" component={CompanyComponent}/>
                    <Route path="/report" component={ReportComponent}/>
                    <Route path="/client/:id" component={ClientComponent}/>
                    <Route path="/client" component={ClientComponent}/>
                    <Route path="/user" component={UserComponent}/>
                </Switch>
            </Authenticate>
        </Switch>
        <Message/>
    </Base>

);


// WEBPACK FOOTER //
// ./src/router.js